'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$7() {
  this.bn5 = null;
  this.bn3 = null;
  this.bn4 = false;
  this.bn1 = null;
  this.bn2 = false;
  this.bn6 = false;
  this.bn7 = false;
  this.bn5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$7 as $c_Lpresto_PrestoRouter$$anon$7 };
$p = $c_Lpresto_PrestoRouter$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$7;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$7() {
}
export { $h_Lpresto_PrestoRouter$$anon$7 as $h_Lpresto_PrestoRouter$$anon$7 };
$h_Lpresto_PrestoRouter$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bn5;
});
$p.t = (function() {
  if ((!this.bn4)) {
    this.bn3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn4 = true;
  }
  return this.bn3;
});
$p.ag = (function() {
  if ((!this.bn2)) {
    this.bn1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn2 = true;
  }
  return this.bn1;
});
$p.v = (function() {
  if ((!this.bn7)) {
    this.bn6 = false;
    this.bn7 = true;
  }
  return this.bn6;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$7, "presto.PrestoRouter$$anon$7", ({
  OL: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$7 as $d_Lpresto_PrestoRouter$$anon$7 };
//# sourceMappingURL=presto.-Presto-Router$$anon$7.js.map
